export const FullScreenIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      d='M1 6.43742H6.43742V1M9.15612 1V6.43742H14.5935M14.5935 9.15612H9.15612L9.15612 14.5935M6.43742 14.5935V9.15612H1'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
